import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d1803b3e"
import script from "./list.ts?vue&type=script&lang=js&external"
export * from "./list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1803b3e')) {
      api.createRecord('d1803b3e', component.options)
    } else {
      api.reload('d1803b3e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=d1803b3e", function () {
      api.rerender('d1803b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/unidademedida/list.vue"
export default component.exports